import axios from "axios";
import params from "../configs/params";
import { refreshAIAssistantAccessToken } from "./aiAssistantAuth";

const aiAssistantApi = axios.create({ baseURL: params.aiAssistantUrl, withCredentials: false });
aiAssistantApi.defaults.headers.common["Content-Type"] = "application/json";
aiAssistantApi.defaults.headers.common["ngrok-skip-browser-warning"] = "true";

aiAssistantApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("accessToken");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Feature-local refresh: the existing core interceptor uses different field
// names from DRF. Do not extend that defect or refactor unrelated clients here.
aiAssistantApi.interceptors.response.use((response) => response, async (error) => {
  const original = error.config;
  const refresh = localStorage.getItem("refreshToken");
  if (error.response?.status !== 401 || !original || original._retry || !refresh) throw error;
  original._retry = true;
  const token = await refreshAIAssistantAccessToken();
  original.headers.Authorization = `Bearer ${token}`;
  return aiAssistantApi.request(original);
});

export default aiAssistantApi;
